let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("glQWR")).then(() => parcelRequire('91hUW'));